import Vue from 'vue'
// Bus.js
export default new Vue ({})


// WEBPACK FOOTER //
// ./src/bus.js